import { useEffect, useState } from "react";
import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";
import { TextInput } from "@/components/ui/Field";
import { ApiError } from "@/lib/apiClient";
import { updateMaintenanceCampaignName } from "@/lib/wartungen";

export function RenameMaintenanceCampaignDialog({
  open,
  campaignId,
  initialName,
  onClose,
  onSaved,
}: {
  open: boolean;
  campaignId: number;
  initialName: string;
  onClose: () => void;
  onSaved: (name: string) => void;
}) {
  const [name, setName] = useState(initialName);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setName(initialName);
    setError(null);
    setSaving(false);
  }, [open, initialName]);

  async function save() {
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Bitte einen Namen eingeben.");
      return;
    }
    if (trimmed.length > 200) {
      setError("Der Name darf höchstens 200 Zeichen lang sein.");
      return;
    }
    setSaving(true);
    setError(null);
    try {
      const result = await updateMaintenanceCampaignName(campaignId, trimmed);
      onSaved(String(result.campaign?.name || trimmed).trim() || trimmed);
      onClose();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Der Name konnte nicht gespeichert werden.");
      setSaving(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Name der Wartung"
      description="Der Name erscheint in der Übersicht und in der iOS-App."
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Abbrechen
          </Button>
          <Button onClick={() => void save()} disabled={saving}>
            {saving ? "Speichern…" : "Speichern"}
          </Button>
        </>
      }
    >
      <TextInput
        label="Name"
        value={name}
        maxLength={200}
        autoFocus
        onChange={(event) => setName(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            void save();
          }
        }}
        error={error}
      />
    </Dialog>
  );
}
